module.exports = __webpack_public_path__ + "img/arrow-right.7b8c099b.svg";